var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBigLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "{styles.img}",
    width: 503,
    height: 272,
    viewBox: "0 0 503 272",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M247.985 286.051L191.545 17.5996C173.684 24.2387 156.681 32.4655 140.678 42.2799L248.128 285.907L247.985 286.051Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M384.589 15.4331L327.578 286.05L436.457 39.1031C420.168 29.5773 402.736 21.6392 384.589 15.4331Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M301.279 280.134L358.434 7.78518C340.001 3.31098 320.855 0.713058 301.279 0.135742V280.134Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M274.283 0.425781C254.707 1.58041 235.703 4.61132 217.414 9.51851L274.283 280.135V0.425781Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M183.55 333.248L20.803 185.166C15.0875 199.599 10.5152 214.753 7.08594 230.197L183.55 333.248Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M170.4 356.917L2.22336 258.773C0.937392 270.175 0.0800781 281.722 0.0800781 293.557V300.917L170.4 356.773V356.917Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8009 115.744C49.5132 129.311 40.3685 143.743 32.5098 159.187L201.686 313.041L59.8009 115.744Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M392.015 333.247L574.337 226.877C570.622 211 565.906 195.413 559.762 180.691L392.015 333.391V333.247Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M223.267 297.021L117.96 57.7236C103.385 68.6926 89.9542 80.8163 77.666 94.2389L223.409 296.877L223.267 297.021Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M352.304 297.021L500.905 90.1978C488.188 76.7752 474.328 64.7959 459.325 53.9712L352.304 297.021Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M373.871 312.896L547.62 154.856C539.333 139.412 529.759 124.835 519.043 111.124L373.871 312.896Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M582.187 298.753V293.558C582.187 280.568 581.044 267.723 579.472 255.166L405.151 356.774L582.187 298.609V298.753Z",
    fill: "white",
    fillOpacity: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigLogo);
export default __webpack_public_path__ + "static/media/big-logo.bbe8dd2b99d70abcbbcb1cb7689b78d6.svg";
export { ForwardRef as ReactComponent };